export default "__VITE_ASSET__HW6GC8VR__"